// import React, { useState } from 'react';
// import PropTypes from 'prop-types';
// import './webcam-file-upload.css';
// import { FaEye } from 'react-icons/fa';
// import WebcamMultiCaptureModal from '../modal/webcam-multi-capture-modal';
// import { FaCamera } from 'react-icons/fa';
// import ViewAllImagesModal from '../viewallimagesmodal/view-all-images-modal';
// import '../viewallimagesmodal/view-all-images-modal.css';

// const WebcamFileUpload = ({ id, onChange, className, documents,isDisabled} ) => {
//   const [files, setFiles] = useState(documents || []);
//   const [showModal, setShowModal] = useState(false);
// const [showViewModal, setShowViewModal] = useState(false); // new modal
//   return (
//     <div className={`file-upload-wrapper ${className}`}>
//       {!isDisabled && (
//          <div className="d-flex gap-2 mb-2">
//       <button
//         type="button"
//         className="btn btn-outline-primary btn-sm d-flex align-items-center gap-2"
//         onClick={() => setShowModal(true)}
//       >
//         <FaCamera />
//         Capture Image
//       </button>
//       {files.length > 0 && (
//        <button
//             type="button"
//             className='btn btn-outline-secondary btn-sm d-flex align-items-center gap-2'
//             onClick={() => setShowViewModal(true)}
//           >
//             <FaEye />
//             View All Images
//           </button>
//           )}
//         </div>
//  )}
//       <WebcamMultiCaptureModal
//         show={showModal}
//         onClose={() => setShowModal(false)}
//         onSubmit={uploadedFiles => {
//           if (uploadedFiles.length > 0) {
//             const newDocuments = uploadedFiles?.map(file => ({
//               id: id, 
//               name: file.fileName,
//               path: file.filePath,
//             }));

//             onChange(newDocuments);
//            setFiles(newDocuments);
//           }
//         }}
//       />


//  <ViewAllImagesModal
//         show={showViewModal}
//         onClose={() => setShowViewModal(false)}
//         documents={files}
//       />
      
//     </div>
//   );
// };

// WebcamFileUpload.propTypes = {
//   id: PropTypes.string,
//   onChange: PropTypes.func.isRequired,
//   className: PropTypes.string,
//   value: PropTypes.string,
//   filePath: PropTypes.string,
//   isDisabled: PropTypes.bool,
// };

// export default WebcamFileUpload;

//latest changes

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './webcam-file-upload.css';
import { FaEye } from 'react-icons/fa';
import WebcamMultiCaptureModal from '../modal/webcam-multi-capture-modal';
import { FaCamera } from 'react-icons/fa';
import '../viewallimagesmodal/view-all-images-modal.css';
import SegmentedImagesModal from '../modal/segmentedimagesmodal/segmented-images-modal';
import { sanitizeUploadKey } from '../sanitizeUploadKeys/sanitizeUploadKeys';
import { useDispatch } from 'react-redux';
import { showToast } from 'Core/redux/toast/slice';
import { MoldService } from '../../../service/api/mold-service';

const WebcamFileUpload = ({ id, onChange, className, documents,isDisabled,toolID,moldInfoID,buttonLabel,maintenanceId = 0, onImageSegmentUploaded, maintenanceData, onMaintenanceSaved, context = 'maintenance', showManageImages = false, onDraftIdUpdate} ) => {
  console.log('WebcamFileUpload: Component rendered with moldInfoID prop:', moldInfoID);
  
  const dispatch = useDispatch();
  const [files, setFiles] = useState(documents || []);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false); // new modal
  const [currentMaintenanceId, setCurrentMaintenanceId] = useState(maintenanceId);
  const [currentMoldInfoID, setCurrentMoldInfoID] = useState(moldInfoID);
  
  // Update currentMaintenanceId when maintenanceId prop changes
  useEffect(() => {
    setCurrentMaintenanceId(maintenanceId);
  }, [maintenanceId]);
  
  // Update currentMoldInfoID when moldInfoID prop changes
  useEffect(() => {
    console.log('WebcamFileUpload: moldInfoID prop changed to:', moldInfoID);
    console.log('WebcamFileUpload: currentMoldInfoID before update:', currentMoldInfoID);
    setCurrentMoldInfoID(moldInfoID);
    console.log('WebcamFileUpload: setCurrentMoldInfoID called with:', moldInfoID);
  }, [moldInfoID]);
  
  // Debug log when currentMoldInfoID changes
  useEffect(() => {
    console.log('WebcamFileUpload: currentMoldInfoID state changed to:', currentMoldInfoID);
  }, [currentMoldInfoID]);
  
  // Monitor changes in maintenanceData prop
  useEffect(() => {
    console.log('WebcamFileUpload: maintenanceData prop changed:', maintenanceData);
    console.log('WebcamFileUpload: moldDocuments in updated maintenanceData:', maintenanceData?.moldDocuments);
    console.log('WebcamFileUpload: moldDocuments length in updated maintenanceData:', maintenanceData?.moldDocuments?.length);
  }, [maintenanceData]);
  
  return (
    <div className={`file-upload-wrapper ${className}`}>
       {/* Hide capture button if disabled */}
      <div className="d-flex gap-2 mb-2">
        <button
          type="button"
          className="btn btn-outline-primary btn-sm d-flex align-items-center gap-2"
          onClick={() => setShowModal(true)}
          disabled={isDisabled}
        >
          <FaCamera />
          Capture Image
        </button>
        {(showManageImages || files.length > 0) && (
          <button
            type="button"
            className='btn btn-outline-secondary btn-sm d-flex align-items-center gap-2'
            onClick={() => {
              console.log('WebcamFileUpload: Manage Images clicked with props:', {
                moldInfoID,
                buttonLabel,
                maintenanceId: context === 'receiving' ? 0 : currentMaintenanceId,
                context
              });
              setShowViewModal(true);
            }}
          >
            <FaEye />
            Manage Images
          </button>
        )}
      </div>
             <WebcamMultiCaptureModal
         show={showModal}
         toolID={toolID}
         moldInfoID={moldInfoID}
         buttonLabel={buttonLabel}
         maintenanceId={currentMaintenanceId}
         maintenanceData={maintenanceData}
         context={context}
                   onClose={() => setShowModal(false)}
          onImageSegmentUploaded={onImageSegmentUploaded}
        onSubmit={uploadedFiles => {
          if (uploadedFiles.length > 0) {
            //const first = uploadedFiles[0];

            const newDocuments = uploadedFiles?.map(file => ({
              id: id, // or generate a unique ID per file if needed
              name: file.fileName,
              path: file.filePath,
            }));

            onChange(newDocuments);

           // setFiles([ ...files, ...newDocuments ]);
           setFiles(newDocuments);
          }
        }}
        onMaintenanceSaved={(newMaintenanceId, newToolID) => {
          console.log('WebcamFileUpload: onMaintenanceSaved called with ID:', newMaintenanceId);
          console.log('WebcamFileUpload: onMaintenanceSaved called with toolID:', newToolID);
          if (newMaintenanceId && newMaintenanceId > 0) {
            setCurrentMaintenanceId(newMaintenanceId);
            // Also call the parent's onMaintenanceSaved callback if provided
            if (onMaintenanceSaved && typeof onMaintenanceSaved === 'function') {
              console.log('WebcamFileUpload: Calling parent onMaintenanceSaved');
              onMaintenanceSaved(newMaintenanceId, newToolID);
            }
          }
        }}
        onDraftIdUpdate={onDraftIdUpdate}
      />

 {/* <ViewAllImagesModal
        show={showViewModal}
        onClose={() => setShowViewModal(false)}
        documents={files}
      /> */}
      {/* <SegmentedImagesModal
   show={showViewModal}
   onClose={() => setShowViewModal(false)}
   documents={files}
 /> */}

       <SegmentedImagesModal
     show={showViewModal}
     onClose={() => setShowViewModal(false)}
     documents={files}
     moldInfoID={currentMoldInfoID}
     buttonLabel={buttonLabel}
     maintenanceId={context === 'receiving' || context === 'release' ? 0 : currentMaintenanceId}
     context={context}
     onDraftIdUpdate={onDraftIdUpdate}
     // Debug log when modal opens
     {...(showViewModal && console.log('WebcamFileUpload: Opening SegmentedImagesModal with:', {
       showViewModal,
       moldInfoID: currentMoldInfoID,
       buttonLabel,
       maintenanceId: context === 'receiving' || context === 'release' ? 0 : currentMaintenanceId,
       context,
       filesLength: files.length,
       moldInfoIDType: typeof currentMoldInfoID,
       buttonLabelType: typeof buttonLabel,
       moldInfoIDValue: currentMoldInfoID,
       buttonLabelValue: buttonLabel
     }))}
    onDelete={async (slotName, index, imageToDelete) => {
      try {
        // Use the image object passed from SegmentedImagesModal if available, otherwise fall back to files[index]
        const fileToDelete = imageToDelete || files[index];
        console.log('WebcamFileUpload: Deleting image:', fileToDelete);
        
        if (fileToDelete && fileToDelete.id) {
          console.log('Deleting image segment with ID:', fileToDelete.id);
          
          // Call the API to delete the image segment
          const response = await MoldService.deleteMoldMaintenanceImageSegment(fileToDelete.id);
          console.log('Delete API response:', response);
          
          if (response.status === 200) {
            console.log('Image segment deleted successfully');
            
            // Remove from local state immediately
            const updated = files.filter((_, i) => i !== index);
            setFiles(updated);
            onChange(updated);
            
            // Show success toast
            dispatch(showToast({ 
              message: 'Image deleted successfully', 
              type: 'success' 
            }));
          } else {
            console.error('Failed to delete image segment:', response);
            dispatch(showToast({ 
              message: 'Failed to delete image', 
              type: 'danger' 
            }));
          }
        } else {
          console.log('No ID found for image, removing from local state only');
          
          // Still remove from local state even if no ID
          const updated = files.filter((_, i) => i !== index);
          setFiles(updated);
          onChange(updated);
        }
      } catch (error) {
        console.error('Error deleting image segment:', error);
        dispatch(showToast({ 
          message: 'Error deleting image: ' + (error.message || 'Unknown error'), 
          type: 'danger' 
        }));
      }
    }}
  />

{/* inline file list rendering here */}
      {/* {files?.map(file => (
        <div className="file-display-box mt-2">
          <span className="file-name-text" title={file.name}>
            {file.name}
          </span>
          <a href={file.path} target="_blank" rel="noopener noreferrer" className="eye-icon-right">
            <FaEye />
          </a>
        </div>
      ))} */}

      {/* {fileName && fileUrl && (
        <div className="file-display-box mt-2">
          <span className="file-name-text" title={fileName}>
            {fileName}
          </span>
          <a href={fileUrl} target="_blank" rel="noopener noreferrer" className="eye-icon-right">
            <FaEye />
          </a>
        </div>
      )} */}
    </div>
  );
};

  WebcamFileUpload.propTypes = {
    id: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    value: PropTypes.string,
    filePath: PropTypes.string,
    isDisabled: PropTypes.bool,
    toolID: PropTypes.string,
    moldInfoID: PropTypes.number,
    buttonLabel: PropTypes.string,
    maintenanceId: PropTypes.number,
    onImageSegmentUploaded: PropTypes.func,
    maintenanceData: PropTypes.object,
    onMaintenanceSaved: PropTypes.func,
    context: PropTypes.string,
    showManageImages: PropTypes.bool,
    onDraftIdUpdate: PropTypes.func,
  };

export default WebcamFileUpload;
